import { useMemo } from "react";
import {
  cn,
  formatNumber,
  getColorFromCssVariable,
  HorizontalBarsChart,
} from "ui";
import { ChartCard } from "../ChartCard";
import { useDatadogQuery } from "../DatadogAnalytics/useDatadogQuery";

type DeclineCodeData = {
  label: string;
  value: number;
  type: string | null;
}[];

export function TopDeclineCodesChart() {
  const { ref, queryStatus, data, error, refetch } =
    useDatadogQuery<DeclineCodeData>({
      chartType: "ERROR_CODES_COUNTS",
    });

  const color = useMemo(() => getColorFromCssVariable("--chart-danger"), []);

  const chartData = useMemo(() => {
    if (!Array.isArray(data) || data.length === 0) return [];

    const total = data.reduce((sum, item) => sum + item.value, 0);

    return [...data]
      .sort((a, b) => b.value - a.value)
      .map((item) => ({
        label: item.label,
        value: item.value,
        percentage: total > 0 ? (item.value / total) * 100 : 0,
        color: color,
      }));
  }, [data, color]);

  return (
    <ChartCard
      ref={ref}
      title="Top error codes"
      description="Breakdown of failed payment attempts by MoneyHash unified error code."
      queryStatus={queryStatus}
      error={error}
      retry={refetch}
      contentClassName={cn(
        "overflow-y-auto",
        chartData.length > 0 && "flex-grow"
      )}
    >
      <HorizontalBarsChart
        items={chartData}
        formatValue={(item) =>
          formatNumber({ value: item.value, compact: true })
        }
      />
    </ChartCard>
  );
}
